import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ButtonDirective,
  DividerComponent,
  LinkDirective
} from '@com-delta-omnichannel/aura';
import { Checkout } from './models/checkout.interfaces';

@Component({
  selector: 'idp-checkout',
  standalone: true,
  imports: [DividerComponent, ButtonDirective, LinkDirective],
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent {
  @Input() content!: Checkout;
  @Output() checkOut: EventEmitter<void> = new EventEmitter<void>();
  @Output() previousButton: EventEmitter<void> = new EventEmitter<void>();
}
